/**
 * 生徒側ページのルーティング設定
 *   nameは原則としてパスと合わせること。
 *   lazyloadを無効化するためcomponent: CompornentNameの形で設定する
 */
import { RouteConfig } from 'vue-router'

// 対象画面import
import Login from '../views/student/Login.vue'
import QrLogin from '../views/student/QrLogin.vue'
import StudySelection from '../views/student/StudySelection.vue'
import StudyTop from '../views/student/StudyTop.vue'
import Study from '../views/student/Study.vue'
import StudyResult from '../views/student/StudyResult.vue'
import StudyResultDetail from '../views/student/StudyResultDetail.vue'
import StudyResultLastMinuteCheck from '../views/student/StudyResultLastMinuteCheck.vue'
import StudyResultResolve from '../views/student/StudyResultResolve.vue'

/**
 * 生徒側ページ群
 *   nameに接頭辞'Student'を付ける
 */
const studentRoutes: Array<RouteConfig> = [
  {
    path: '/student/login',
    name: 'StudentLogin',
    component: Login,
  },
  {
    path: '/student/qr-login',
    name: 'StudentQrLogin',
    component: QrLogin,
  },
  {
    path: '/student/study-selection',
    name: 'StudentStudySelection',
    component: StudySelection,
  },
  {
    path: '/student/study-top',
    name: 'StudentStudyTop',
    component: StudyTop,
  },
  {
    path: '/student/study',
    name: 'StudentStudy',
    component: Study,
  },
  {
    path: '/student/study-result',
    name: 'StudentStudyResult',
    component: StudyResult,
  },
  {
    path: '/student/study-result-detail/:paperTestId',
    name: 'StudentStudyResultDetail',
    component: StudyResultDetail,
  },
  {
    path: '/student/study-result-last-minute-check/:sUnitId',
    name: 'StudentStudyResultLastMinuteCheck',
    component: StudyResultLastMinuteCheck,
  },
  {
    path: '/student/study-result-resolve/:sUnitId',
    name: 'StudentStudyResultResolve',
    component: StudyResultResolve,
  },
]

export default studentRoutes
